export const DEFAULT_GRADIENT_ID = 'default-gradient-id';
